import { UserProfile } from "@app/api/admin";

// const avatarImg = process.env.REACT_APP_ASSETS_BUCKET + '/avatars/avatar5.webp';


export const persistToken = (token: string): void => {
  localStorage.setItem('token', token);
};

export const readToken = (): string => {
  return localStorage.getItem('token') || ''
};

export const persistUser = (user: UserProfile): void => {
  localStorage.setItem('user', JSON.stringify(user));
};

export const readUser = (): UserProfile | null => {
  const userStr = localStorage.getItem('user');

  return userStr ? JSON.parse(userStr) : { id: 0, username: '', email: '', nickname: '' } as any;
};

export const deleteToken = (): void => localStorage.removeItem('token');
export const deleteUser = (): void => localStorage.removeItem('user');
